// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1024px){.imgpos[data-v-4ba9410e]{transform:translateX(5rem)}}.border-bottom[data-v-4ba9410e]:after{content:\"\";display:block;background-color:#000;height:1px;width:100%;z-index:30;position:absolute}.icon-container[data-v-4ba9410e]{max-width:500px}.icon-container>div[data-v-4ba9410e]{margin-right:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
